import produce from "immer";

import { useGlobal } from "../../contexts/globalContext";
import Janus from "../../utils/janus";

/**
 * @description Represents the track names for different types of audio and video tracks in a meeting.
 *
 * @property {string} MEETING_VIDEO - The track name for the meeting video track ("v110-mini").
 * @property {string} MEETING_AUDIO - The track name for the meeting audio track ("a110-meet").
 * @property {string} SCREEN_AUDIO - The track name for the screen audio track ("a101").
 */
export const TRACK_NAME = {
  MEETING_CAMERAS: "v110-mini",
  MEETING_AUDIO: "a110-meet",
  SCREEN_AUDIO: "a101",
  MAIN_STREAM: "v101",
};

export const useTracksHandler = () => {
  const {
    SET_MEETING_STATE,
    SET_SCREEN_STATE,
    SET_MEDIA_TRACKS,
    SCREEN_STREAM_MAIN_REF,
    SCREEN_STREAM_TEMP_REF,
    SCREEN_STREAM_AUDIO_REF,
    SCREEN_SOUND__REF,

    AUDIO_SCREEN_SOUND,
    AUDIO_SCREEN,

    VIDEO_MAIN_HIDDEN,
    VIDEO_TEMP_HIDDEN,
  } = useGlobal();

  /**
   * Handles tracks for various types of media in a meeting.
   * @param {MediaStreamTrack} track - The media track to handle.
   * @param {string} mid - The Media ID associated with the track.
   */
  const tracksHandler = (track, mid, oldScreensArray) => {
    const clonedTrack = track.clone();
    const stream = new MediaStream();

    if (mid === TRACK_NAME.MAIN_STREAM) {
      if (!SCREEN_STREAM_MAIN_REF.current.id || !SCREEN_STREAM_MAIN_REF.current.active) SCREEN_STREAM_MAIN_REF.current.addTrack(clonedTrack);
      console.log(clonedTrack);
      Janus.attachMediaStream(VIDEO_MAIN_HIDDEN.current, SCREEN_STREAM_MAIN_REF.current);
    }

    // meeting cameras
    if (mid.replace("janus", "") === TRACK_NAME.MEETING_CAMERAS) {
      stream.addTrack(clonedTrack);
      SET_MEETING_STATE((p) => ({
        ...p,
        meetingVideoStream: stream,
      }));
      // screen audio
    } else if (mid === TRACK_NAME.SCREEN_AUDIO) {
      stream.addTrack(clonedTrack);
      SET_MEETING_STATE((p) => ({
        ...p,
        screenAudioStream: stream,
      }));

      SCREEN_SOUND__REF.current.addTrack(clonedTrack);

      Janus.attachMediaStream(AUDIO_SCREEN_SOUND.current, SCREEN_SOUND__REF.current);
    }
    // meeting audio
    else if (mid === TRACK_NAME.MEETING_AUDIO) {
      stream.addTrack(clonedTrack);
      SET_MEETING_STATE((p) => ({
        ...p,
        meetingAudioStream: stream,
      }));
    } else {
      SET_SCREEN_STATE((prevScreenState) => {
        if (prevScreenState.currentScreen.state === "initializing") {
          if (track.kind === "audio") {
            // screen audio track
            SCREEN_STREAM_AUDIO_REF.current.addTrack(clonedTrack);
            Janus.attachMediaStream(AUDIO_SCREEN.current, SCREEN_STREAM_AUDIO_REF.current);
          }
          // screens video tracks
          else {
            // screen base
            const baseScreen = oldScreensArray.find((x) => x.id === -1);
            if (baseScreen && mid === baseScreen.mini_track_name) {
              if (!SCREEN_STREAM_TEMP_REF.current.id || !SCREEN_STREAM_TEMP_REF.current.active) SCREEN_STREAM_TEMP_REF.current.addTrack(clonedTrack);

              Janus.attachMediaStream(VIDEO_TEMP_HIDDEN.current, SCREEN_STREAM_TEMP_REF.current);
            }

            window.sm = SCREEN_STREAM_MAIN_REF.current;
            SET_MEDIA_TRACKS((prev) =>
              produce(prev, (draft) => {
                if (!draft[mid]) draft[mid] = clonedTrack;
              }),
            );
          }
        }

        return prevScreenState;
      });
    }
  };

  return {
    tracksHandler,
  };
};
